import React, { useState, useEffect } from "react";
import EucRegularienComponent from '../components/EucRegularienComponent';

const EucRegularienContainer = (props) => {
    return <EucRegularienComponent {...props} />;
};

export default EucRegularienContainer;